export default {
  INIT: 'DRIVER/INIT',
  UPDATE_DATA: 'DRIVER/UPDATE_DATA',
}
